// extracted by mini-css-extract-plugin
export var PostCard__title = "PostCard__title_JynAm";